import { t } from "i18next";
import { Controller, useFormContext } from "react-hook-form";
import { SelectList } from "ui";

import { ORDER_STATUSES_LIST } from "../../../../constants";
import { FilterFormValues } from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

export const StatusBlock = () => {
  const { control, watch } = useFormContext<FilterFormValues>();

  const selectedUnpackingStatus = watch("unpackingStatus");

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>{t("Status")}</h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name="statuses"
          render={({ field: { onChange, value } }) => (
            <SelectList
              value={value}
              onChange={onChange}
              options={ORDER_STATUSES_LIST}
              disabled={!!selectedUnpackingStatus}
            />
          )}
        />
      </div>
    </div>
  );
};
